import { useEffect } from "react";
import { getPairing } from "@/lib/fonts";

const hexToRgba = (hex, a) => {
  const h = (hex || "").replace("#", "");
  if (!h) return `rgba(184,134,11,${a})`;
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255;
  return `rgba(${r},${g},${b},${a})`;
};

// Applies CMS-controlled brand colors (light mode) + font pairing (both modes) live.
export const BrandStyle = ({ theme }) => {
  const pairing = getPairing(theme?.font_pairing);

  useEffect(() => {
    const id = "cms-font-link";
    let link = document.getElementById(id);
    if (!link) {
      link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = pairing.url;
  }, [pairing.url]);

  if (!theme) return null;

  const css = `:root:not(.dark){
    --gold: ${theme.primary};
    --gold-hover: ${theme.primary};
    --burgundy: ${theme.secondary};
    --footer-bg: ${theme.secondary};
    --ivory: ${theme.background};
    --surface: ${theme.surface};
    --rose: ${theme.accent};
    --border-gold: ${hexToRgba(theme.primary, 0.3)};
  }
  :root{
    --font-serif: ${pairing.serif};
    --font-body: ${pairing.body};
    --font-script: ${pairing.script};
  }`;
  return <style dangerouslySetInnerHTML={{ __html: css }} />;
};
